import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import classNames from "classname";
import BreadcrumbsData from "../variables/variables";

let ariaCurrent = "aria-current='page'";

const Breadcrumbs = (props) => {
  const router = useRouter();
  const [breadcrumbs, setBreadcrumbs] = useState(null);

  // PROPS VARIABLE
  let propsMiasto = props.miasto;
  let propsPodatek = props.podatek;

  let propsType;
  let extendedUrl = "";
  let siteCode = router.query.siteCode;

  if (BreadcrumbsData.miasta[propsMiasto].index) {
    propsType = "/";
  } else if (BreadcrumbsData.miasta[propsMiasto].witryna) {
    propsType = "/witryna/";
    extendedUrl = "?siteCode=" + siteCode;
  } else {
    propsType = "/" + BreadcrumbsData.miasta[propsMiasto].name.url + "/";
  }

  const convertBreadcrumb = (string) => {
    const s = string.split("?")[0];

    const BreadcrumbText = {
      witryna: `Przyjazne Deklaracje ${BreadcrumbsData.miasta[propsMiasto].name.who}`,
      kontakt: "Kontakt",
      "mapa-strony": "Mapa strony",
      "deklaracja-dostepnosci": "Deklaracja dostępności",
      "podatek-od-srodkow-transportowych": "Podatek od środków transportowych",
      "podatek-od-nieruchomosci": "Podatek od nieruchomości",
      "podatek-rolny": "Podatek rolny",
      "podatek-lesny": "Podatek leśny",
      "oplata-za-gospodarowanie-odpadami-komunalnymi":
        "Opłata za gospodarowanie odpadami komunalnymi",
      "dla-mieszkanca": "Dla Mieszkańca",
      "dla-samorzadu": "Dla Samorządu",
      "abc-podatkow": "ABC podatków",
      "jak-to-dziala": "Jak to działa",
      "wazne-terminy": "Ważne terminy",
      aktualnosci: "Aktualności",
      wyszukiwarka: "Wyszukiwarka",
    };

    return (
      BreadcrumbText[s] ??
      `Przyjazne Deklaracje ${BreadcrumbsData.miasta[propsMiasto].name.who}`
    );
  };

  useEffect(() => {
    if (router) {
      const linkPath = router.asPath.split("/");
      linkPath.shift();

      const pathArray = linkPath.map((path, i) => ({
        breadcrumb: path,
        href: `/${linkPath.slice(0, i + 1).join("/")}`,
      }));

      setBreadcrumbs(pathArray);
    }
  }, [router]);

  if (!breadcrumbs) {
    return null;
  }

  return (
    <section
      className={classNames("pd-breadcrumbs", {
        "pd-breadcrumbs--light": props.layout === "light",
        "pd-breadcrumbs--dark": props.layout === "dark",
      })}
    >
      <nav aria-label="Breadcrumbs">
        <ul className="pd-breadcrumbs__list">
          <li>
            <a
              href={`/${BreadcrumbsData.miasta[propsMiasto].name.url}/`}
              aria-label={`Przyjazne Deklaracje ${BreadcrumbsData.miasta[propsMiasto].name.who}`}
            >
              {`Przyjazne Deklaracje ${BreadcrumbsData.miasta[propsMiasto].name.who}`}
            </a>
          </li>

          {breadcrumbs.map((breadcrumb, i) => {
            if (i >= 0 && i < breadcrumbs.length - 1) {
              return (
                <li key={i}>
                  <a
                    href={`/${BreadcrumbsData.miasta[propsMiasto].name.url}${breadcrumb.href}/`}
                    aria-label={convertBreadcrumb(breadcrumb.breadcrumb)}
                  >
                    {convertBreadcrumb(breadcrumb.breadcrumb)}
                  </a>
                </li>
              );
            }
            return null;
          })}
        </ul>
      </nav>
    </section>
  );
};

export default Breadcrumbs;
